import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_DataSheet = ({
	itemsRef,
	showErrorFor,
}) => {

	return (
		<form id='ACTS_DataSheet' className='file-pdf-document'>
			<div className='file-template'>
				<h3>
					PSB Data Sheet
				</h3>
				<h4>
					(preliminary info to aid in case disposition and/or safety planning)
				</h4>
				<table>
					<tr>
						<td className='w-250'>
							<span className='eleHeader'>Agency</span>
							<input type="text" id="txtAgency" name="txtAgency" className='add-only' />
						</td>
						<td className='w-250'>
							<span className='eleHeader'>Team</span>
							<input type="text" id="txtTeam" name="txtTeam" className='add-only' />
						</td>
						<td className='w-250'>
							<span className='eleHeader'>Date</span>
							<input type="date" id="txtDate" name="txtDate" className='add-only' />
						</td>
					</tr>
				</table>
				<p className='w-750'>
					<b>Youth Name (first name, last initial)</b> <input type="text" id="txtYouthName" name="txtYouthName" className='add-only' />
				</p>
				<table>
					<tr>
						<td className='w-750'>
							<span className='eleHeader'>Where is youth living right now?</span>
						</td>
					</tr>
					<tr>
						<td className='w-375'>
							<input type="checkbox" id="cbYouth1" name="cbYouth1" className='add-only' value="Youth1" />
							in detention or a residential
						</td>
						<td className='w-375'>
							<input type="text" id="txtYouth1" name="txtYouth1" className='add-only' />
						</td>
					</tr>
					<tr>
						<td className='w-375'>
							<input type="checkbox" id="cbYouth2" name="cbYouth2" className='add-only' value="Youth2" />
							in a relative's home <span className='small'>(no known victim of youth residing there)</span>
						</td>
						<td className='w-375'>
							<input type="text" id="txtYouth2" name="txtYouth2" className='add-only' />
						</td>
					</tr>
					<tr>
						<td className='w-375'>
							<input type="checkbox" id="cbYouth3" name="cbYouth3" className='add-only' value="Youth3" />
							in same home as his/her victim(s)
						</td>
						<td className='w-375'>
							<input type="text" id="txtYouth3" name="txtYouth3" className='add-only' />
						</td>
					</tr>
					<tr>
						<td className='w-375'>
							<input type="checkbox" id="cbYouth4" name="cbYouth4" className='add-only' value="Youth4" />
							in group or foster care home
						</td>
						<td className='w-375'>
							<input type="text" id="txtYouth5" name="txtYouth5" className='add-only' />
						</td>
					</tr>
				</table>
				<p className='w-750'>
					<span className='eleHeader'>Whose home will youth reside in during initial treatment phase?</span>
					<textarea id="txtPerformanceTreatment" name="txtPerformanceTreatment" className='add-only'></textarea>
				</p>
				<table>
					<tr>
						<td className='w-375'>
							<span className='eleHeader'>Name</span>
							<input type="text" id="txtAgencyName1" name="txtAgencyName1" className='add-only' />
						</td>
						<td className='w-375'>
							<span className='eleHeader'>Relationship</span>
							<input type="text" id="txtTeamRelationship1" name="txtTeamRelationship1" className='add-only' />
						</td>
					</tr>
				</table>
				<p className='w-750'>
					<span className='eleHeader'>Permanent residency plans </span><span className='small'>(if different)?</span>
					<textarea id="txtPerformanceTreatment1" name="txtPerformanceTreatment1" className='add-only'></textarea>
				</p>
				<table>
					<tr>
						<td className='w-375'>
							<span className='eleHeader'>Name</span>
							<input type="text" id="txtAgencyName2" name="txtAgencyName2" className='add-only' />
						</td>
						<td className='w-375'>
							<span className='eleHeader'>Relationship</span>
							<input type="text" id="txtTeamRelationship3" name="txtTeamRelationship2" className='add-only' />
						</td>
					</tr>
				</table>
				<table>
					<tr>
						<td className='w-750'>
							<span className='eleHeader'>Legal Status</span>
						</td>
					</tr>
					<tr>
						<td className='w-150'>
							<input type="checkbox" id="cbLegal1" name="cbLegal1" className='add-only' value="Legal1" /> charges pending
						</td>
						<td className='w-150'>
							<input type="checkbox" id="cbLegal2" name="cbLegal2" className='add-only' value="Legal2" /> on probation
						</td>
						<td className='w-450'>
							<input type="checkbox" id="cbLegal3" name="cbLegal3" className='add-only' value="Legal3" /> no legal involvement/criminal charges
						</td>
					</tr>
					<tr>
						<td className='w-150'>
							<input type="checkbox" id="cbLegal4" name="cbLegal4" className='add-only' value="Legal4" /> on parole
						</td>
						<td className='w-600'>
							<input type="checkbox" id="cbLegal5" name="cbLegal5" className='add-only' value="Legal5" /> abuse and neglect investigation (no charges yet)
						</td>
					</tr>
				</table>
				<h4>
					Specific PSB Behaviors
				</h4>
				<table>
					<tr>
						<td className='w-250'>
							<span className='eleHeader'>What</span>
							<input type="text" id="txtWhat" name="txtWhat" className='add-only' />
						</td>
						<td className='w-250'>
							<span className='eleHeader'>To Whom</span>
							<input type="text" id="txtToWhom" name="txtToWhom" className='add-only' />
						</td>
						<td className='w-250'>
							<span className='eleHeader'>When</span>
							<input type="date" id="txtWhenDate" name="txtWhenDate" className='add-only' />
						</td>
					</tr>
					<tr>
						<td className='w-250'>
							<input type="text" id="txtWhat1" name="txtWhat1" className='add-only' />
						</td>
						<td className='w-250'>
							<input type="text" id="txtToWhom1" name="txtToWhom1" className='add-only' />
						</td>
						<td className='w-250'>
							<input type="date" id="txtWhenDate1" name="txtWhenDate1" className='add-only' />
						</td>
					</tr>
					<tr>
						<td className='w-250'>
							<input type="text" id="txtWhat2" name="txtWhat2" className='add-only' />
						</td>
						<td className='w-250'>
							<input type="text" id="txtToWhom2" name="txtToWhom2" className='add-only' />
						</td>
						<td className='w-250'>
							<input type="date" id="txtWhenDate2" name="txtWhenDate2" className='add-only' />
						</td>
					</tr>
					<tr>
						<td className='w-250'>
							<input type="text" id="txtWhat3" name="txtWhat3" className='add-only' />
						</td>
						<td className='w-250'>
							<input type="text" id="txtToWhom3" name="txtToWhom3" className='add-only' />
						</td>
						<td className='w-250'>
							<input type="date" id="txtWhenDate3" name="txtWhenDate3" className='add-only' />
						</td>
					</tr>
					<tr>
						<td className='w-250'>
							<input type="text" id="txtWhat4" name="txtWhat4" className='add-only' />
						</td>
						<td className='w-250'>
							<input type="text" id="txtToWhom4" name="txtToWhom4" className='add-only' />
						</td>
						<td className='w-250'>
							<input type="date" id="txtWhenDate4" name="txtWhenDate4" className='add-only' />
						</td>
					</tr>
				</table>
				<p className='w-750'>
					<span className='eleHeader'>Status of clarification work with adult caregivers</span> <span className='small'>(and secondarily, youth)</span>
					<textarea id="txtStatus" name="txtStatus" className='add-only'></textarea>
				</p>
				<p className='w-750'>
					<span className='eleHeader'>Has victim (s) received an evaluation for trauma?</span>
					<input type="radio" id="rbReceived1_Yes" name="rbReceived1" className='add-only' value="1" /> Yes&nbsp;
					<input type="radio" id="rbReceived1_No" name="rbReceived1" className='add-only' value="0" /> No
				</p>
				<p className='w-750'>
					<span className='eleHeader'>Is victim in therapy </span> <span className='small'>(for trauma)?</span>
					<input type="radio" id="rbReceived2_Yes" name="rbReceived2" className='add-only' value="1" /> Yes&nbsp;
					<input type="radio" id="rbReceived2_No" name="rbReceived2" className='add-only' value="0" /> No
				</p>
				<table>
					<tr>
						<td className='w-375'>
							<span className='eleHeader'>Provider</span>
							<input type="text" id="txtProvider" name="txtProvider" className='add-only' />
						</td>
						<td className='w-375'>
							<span className='eleHeader'>Where does the victim live?</span>
							<input type="text" id="txtVictim" name="txtVictim" className='add-only' />
						</td>
					</tr>
					<tr>
						<td className='w-750'>
							<span className='eleHeader'>Any contact or risk of contact with the victim?</span>
							<input type="text" id="txtProvider1" name="txtProvider1" className='add-only' />
						</td>
					</tr>
				</table>
				<p className='w-750'>
					<span className='eleHeader'>Has provider authorized any contact with PSB client?</span>
					<input type="radio" id="rbReceived3_Yes" name="rbReceived3" className='add-only' value="1" /> Yes&nbsp;
					<input type="radio" id="rbReceived3_No" name="rbReceived3" className='add-only' value="0" /> No
				</p>
				<p className='w-750'>
					<span className='eleHeader'>Is there any evidence that PSB youth groomed victims?</span>
					<input type="radio" id="rbReceived4_Yes" name="rbReceived4" className='add-only' value="1" /> Yes&nbsp;
					<input type="radio" id="rbReceived4_No" name="rbReceived4" className='add-only' value="0" /> No
				</p>
				<p className='w-750'>
					<span className='eleHeader'>Provide details</span>
					<textarea id="txtStatusProvide1" name="txtStatusProvide1" className='add-only'></textarea>
				</p>
				<p className='w-750'>
					<span className='eleHeader'>Initial impression of engagement with caretakers with whom the youth will be living </span><span className='small'>(if you
						have had contact)</span>
					<textarea id="txtStatusProvide2" name="txtStatusProvide2" className='add-only'></textarea>
				</p>
				<p className='w-750'>
					<span className='eleHeader'>Describe or draw a diagram of the living arrangements. Please note any safety concerns
						and/or supervision concerns based on the living arrangements.</span>
					<textarea id="txtStatusProvide3" name="txtStatusProvide3" className='add-only'></textarea>
				</p>






			</div>
		</form>

	)
}  
